import React from 'react';
import Spinner from '../spinner/Spinner';

//Componentes

//Estilos
import './Comments.css';

function Comments({ functions, states }) {
    const { loader } = states;
    const {
        register,
        handleSubmit,
        setError,
        formState: { errors },
        onSubmit,
    } = functions;

    return (
        <div className="comments-container">
            <h4>Su comentario es importante</h4>
            <p>
                Este espacio de contacto nos permite conocer y tomar en cuenta
                su opinión para introducir mejoras en el sistema
            </p>
            <form className="comments-form" onSubmit={handleSubmit(onSubmit)}>
                <textarea
                    className="comments-textarea"
                    rows="3"
                    {...register('comentario', {
                        required: 'Debe ingresar un comentario',
                    })}
                ></textarea>
                {errors.comentario && (
                    <small className="form__error">
                        {errors.comentario.message}
                    </small>
                )}
                <button
                    className="btn btn-primary"
                    disabled={loader}
                    style={{ margin: 0 }}
                >
                    Enviar
                </button>
                {/* {loader ? (
                    <span style={{ maxWidth: 10 }}>
                        <Spinner />
                    </span>
                ) : null} */}
            </form>
        </div>
    );
}

export default Comments;
